import React, { useState } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";

const DxLimitationSelectFragment = ({
  updateRulesAfterEdit,
  editable,
  params,
  options,
}) => {
  return (
    <>
      <FormControl aria-label="Form Control Limitation" fullWidth>
        <Select
          disabled={!editable}
          id={"dxLimitationSelect_" + params.id}
          name={"dxOption_" + params.id}
          value={params.row?.RuleFacts?.DXLimitation}
          required
          sx={{ "& .MuiSelect-select": { padding: "7.5px 10px" } }}
          onChange={(event) => {
            const selectedOption = options.find(
              (option) => option.apeaValueText === event.target.value
            );
            let newRow = structuredClone(params.row);
            newRow.RuleFacts.DXLimitation = event.target.value;
            newRow.RuleFacts.DXDisplayValueKey = selectedOption
              ? String(selectedOption.dxLimitationKey)
              : "";
            updateRulesAfterEdit(newRow, params.row);
          }}
          inputProps={{ "aria-label": "Diagnosis Limitation Select" }}
        >
          {options.map((option) => (
            <MenuItem key={option.apeaValueText} value={option.apeaValueText}>
              {option.displayValueText}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default DxLimitationSelectFragment;
